module.exports = __webpack_public_path__ + "static/img/zhuanti2.73059c73.png";